import { computed, normalizeClass, type MaybeRefOrGetter, toValue } from 'vue';

type ClassValue = string | Record<string, boolean> | (string | Record<string, boolean>)[] | null | undefined;

/**
 * Composable to merge multiple class values into a normalized string.
 * Uses Vue's normalizeClass utility for consistent class handling.
 *
 * @param classes - Class values to merge (strings, arrays, objects, or reactive getters)
 * @returns Computed normalized class string
 */
export function useNormalizedClass(...classes: MaybeRefOrGetter<ClassValue>[]) {
  return computed(() => normalizeClass(classes.map(toValue)));
}
